import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {rootReducer} from "../store";

export const documentDurationsApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'documentDurationsApi',
  endpoints: (builder) => ({
    getDocumentDurations: builder.query<DocumentDurationItem[], string>({
      query: (query) => `certification/v4.0/document_durations/`,
    }),
  }),
})

export const documentDurationsSlice = createSlice({
  name: 'documentDurations',
  initialState: {
    documentDurations: [] as DocumentDurationItem[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      documentDurationsApi.endpoints.getDocumentDurations.matchFulfilled,
      (state, { payload }) => {
        state.documentDurations = payload
      }
    );
  },
})

export const { useLazyGetDocumentDurationsQuery } = documentDurationsApi

export const useDocumentDurations = () => {
  return useSelector(({ documentDurations }: ReturnType<typeof rootReducer>) => documentDurations.documentDurations)
}
